import { type INote, type ITimelineItem } from '@/types/INote';

export const convertNoteToTimelineItem = (note: INote): ITimelineItem => {
  return {
    id: note.id,
    publicationDate: note.publicationDate,
    title: note.title,
  };
};
